import script from "./CrudCodigosDefectos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudCodigosDefectos.vue?vue&type=script&setup=true&lang=js"

import "./CrudCodigosDefectos.vue?vue&type=style&index=0&id=02327f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02327f46"]])

export default __exports__